import React, { useCallback, useMemo, useState } from 'react';
import { toast } from 'react-toastify';

import { useAuth } from '@/provider/UserProvider';

import { FEED_FILTER_TYPE } from './side-bar';

interface FeedInterface {
  data: any;
  contextActionGenerator: any;
}

const defaultFeed: FeedInterface = {
  data: null,
  contextActionGenerator: null,
};

const FeedContext = React.createContext(defaultFeed);

export default FeedContext;

export const FeedProvider: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  // value

  const [showWalletModal, setShowWalletModal] = useState(false);
  const [filterStatus, setFilterStatus] = useState(FEED_FILTER_TYPE.all);
  const [refreshWhenFollowNewUser, setRefreshWhenFollowNewUser] = useState(null);
  const [refreshFeed, setRefreshFeed] = useState(false);
  const [refreshFollow, setRefreshFollow] = useState(false);
  const { auth, isLogin } = useAuth();

  // wallet value
  // const context = useWeb3React();
  // const { account } = context;
  const { wallet, publicAddress } = { publicAddress: auth.user.publicAddress, wallet: {} };

  const data = {
    showWalletModal,
    refreshWhenFollowNewUser,
    filter: filterStatus,
    wallet: publicAddress && publicAddress !== '0x' ? wallet : null,
    publicAddress,
    // erc20Wallet: account && account !== '0x' ? account : null,
    refreshFeed,
    refreshFollow,
  };

  const setFilterStatusWithLoggedIn = useCallback((filter: any) => {
    if (!isLogin) {
      return toast.error('You must login to continue!');
    }
    setFilterStatus(filter);
  }, []);

  const valueData = useMemo(
    () => ({
      data,
      contextActionGenerator: {
        setShowWalletModal,
        setFilterStatusWithLoggedIn,
        setRefreshWhenFollowNewUser,
        setRefreshFeed,
        setRefreshFollow,
      },
    }),
    [data],
  );

  return <FeedContext.Provider value={valueData}>{children}</FeedContext.Provider>;
};
